import React from 'react';

export const LITE_URL = 'https://lite.myocean.tech/login';
